"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PutBucketPolicyInput_1 = require("./PutBucketPolicyInput");
var PutBucketPolicyOutput_1 = require("./PutBucketPolicyOutput");
var ServiceMetadata_1 = require("./ServiceMetadata");
exports.PutBucketPolicy = {
    metadata: ServiceMetadata_1.ServiceMetadata,
    name: "PutBucketPolicy",
    http: {
        method: "PUT",
        requestUri: "/{Bucket}?policy"
    },
    input: {
        shape: PutBucketPolicyInput_1.PutBucketPolicyInput
    },
    output: {
        shape: PutBucketPolicyOutput_1.PutBucketPolicyOutput
    },
    errors: []
};
//# sourceMappingURL=PutBucketPolicy.js.map